module.exports = __webpack_public_path__ + "img/6_001.131a3733.webp";